const AiletEligibilityHeader = [
    { id: 1, label: "Eligbility Criteria", var: "eligbilitycriteria" },
    { id: 2, label: "Qualifying Exam", var: "qualifyingexam" },
    { id: 3, label: "Age-limit", var: "agelimit" },
    { id: 4, label: "Total Number of Attempts", var: "totalnumberofattempts" },
    { id: 5, label: "Subject Combination", var: "subjectcombination" },
    { id: 6, label: "Reservation of Seats", var: "reservationofseats" },
];
export default AiletEligibilityHeader;